import type { ButtonProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { CheckboxField, SelectField, TextField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const VARIANT = ["primary", "secondary", "ghost"] as const;
const TARGET = ["_self", "_blank"] as const;
const ALIGN = ["left", "center", "right"] as const;

export function ButtonInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as ButtonProps;

  return (
    <>
      <TextField
        label="Label"
        value={p.text}
        onChange={(v) => update(widget.id, { text: v })}
      />
      <TextField
        label="Link (href)"
        value={p.href}
        onChange={(v) => update(widget.id, { href: v })}
      />
      <SelectField
        label="Variant"
        value={p.variant ?? "primary"}
        options={VARIANT}
        onChange={(v) => update(widget.id, { variant: v })}
      />
      <SelectField
        label="Target"
        value={p.target ?? "_self"}
        options={TARGET}
        onChange={(v) => update(widget.id, { target: v })}
      />
      <SelectField
        label="Align"
        value={p.align ?? "left"}
        options={ALIGN}
        onChange={(v) => update(widget.id, { align: v })}
      />
      <CheckboxField
        label="Full width"
        value={p.fullWidth ?? false}
        onChange={(v) => update(widget.id, { fullWidth: v })}
      />
    </>
  );
}
